/**
 * @param args 需要合并的对象
 * @returns 合并后的对象
 */
export function extend(...args) {
  let target = args[0];
  if (args.length === 1) {
    return args[0];
  }
  //当第一个参数不是对象时
  if (typeof target != "object") {
    target = {};
  }

  for (let i = 1; i < args.length; i++) {
    let source = args[i];
    //不为对象时，查找下个节点
    if (typeof source != "object") {
      continue;
    }

    for (let prop in source) {
      let item = source[prop];
      if (Array.isArray(item)) {
        if (!Array.isArray(target[prop])) {
          target[prop] = [];
        }
        item.map(function(arr, index) {
          if (typeof arr !== "object") {
            target[prop][index] = arr;
          } else {
            target[prop][index] = extend(target[prop][index], arr);
          }
        });
      } else if (typeof item === "function") {
        target[prop] = item;
      } else if (item instanceof Object) {
        target[prop] = extend(target[prop], item);
      } else {
        target[prop] = item;
      }
    }
  }
  return target;
}

export function copy(...args) {
  if (Array.isArray(args[0])) {
    return extend([], ...args);
  }
  return extend({}, ...args);
}

/**
 * @method [checkIpInSameSegment] [用于判断两个IP地址是否同网段]
 * @param  {string} ip_lan   [lan口IP地址]
 * @param  {string} mask_lan [lan口子网掩码]
 * @param  {string} ip_wan   [wan口IP地址]
 * @param  {string} mask_wan [wan口子网掩码]
 * @return {booleans}        [若在同一网段，则返回true, 不在同一网段，返回false]
 */
export function checkIpInSameSegment(ip_lan, mask_lan, ip_wan, mask_wan) {
  if (ip_lan == "" || ip_wan == "") {
    return false;
  }

  if (mask_lan == "0.0.0.0" || mask_wan == "0.0.0.0") {
    return false;
  }

  let ip1Arr = ip_lan.split("."),
    ip2Arr = ip_wan.split("."),
    maskArr1 = mask_lan.split("."),
    maskArr2 = mask_wan.split("."),
    maskArr = maskArr1,
    i;
  for (i = 0; i < 4; i++) {
    if (maskArr1[i] != maskArr2[i]) {
      if ((maskArr1[i] & maskArr2[i]) == maskArr1[i]) {
        maskArr = maskArr1;
      } else {
        maskArr = maskArr2;
      }
      break;
    }
  }
  for (i = 0; i < 4; i++) {
    if ((ip1Arr[i] & maskArr[i]) != (ip2Arr[i] & maskArr[i])) {
      return false;
    }
  }
  return true;
}

/**
 * @method [checkIpInSameSegment] [用于判断两个IP地址是否同网段]
 * @param  {string} ip_first   [被检测IP]
 * @param  {string} mask_first [被检测子网掩码]
 * @param  {string} ip_second   [检测IP]
 * @param  {string} mask_second [检测子网掩码]
 * @return {string}             [返回校验错误，没有则返回空]
 */

export function validIpInSameSegment(
  ip_first,
  mask_first,
  ip_second,
  mask_second,
  text_first,
  text_second
) {
  let msg = checkIpInSameSegment(ip_first, mask_first, ip_second, mask_second);

  return msg
    ? _("%s and %s (%s) cannot be on the same network segment", [
        text_first,
        text_second,
        ip_second,
      ])
    : "";
}

/**
 * @method [检查IP地址是否为网段或广播IP合法性]
 * @param  {string} ip   [IP地址]
 * @param  {string} mask [子网掩码]
 * @param  {string} str  [提示信息，用于表示ip是什么地址]
 * @return {string}      [若检查有错，则返回报错提示语。否则，返回为空]
 */
export function checkIsVoildIpMask(ip, mask) {
  let ipArry,
    maskArry,
    len,
    maskArry2 = [],
    netIndex = 0,
    netIndex1 = 0,
    broadIndex = 0,
    i = 0;
  (ipArry = ip.split(".")), (maskArry = mask.split(".")), (len = ipArry.length);

  for (i = 0; i < len; i++) {
    maskArry2[i] = 255 - Number(maskArry[i]);
  }

  for (let k = 0; k < 4; k++) {
    // ip & mask
    if ((ipArry[k] & maskArry[k]) == 0) {
      netIndex1 += 0;
    } else {
      netIndex1 += 1;
    }
  }
  for (let k = 0; k < 4; k++) {
    // ip & 255 - mask
    if ((ipArry[k] & maskArry2[k]) == 0) {
      netIndex += 0;
    } else {
      netIndex += 1;
    }
  }

  if (netIndex == 0 || netIndex1 == 0) {
    return _("IP address cannot be a network address");
  }

  for (let j = 0; j < 4; j++) {
    if ((ipArry[j] | maskArry[j]) == 255) {
      broadIndex += 0;
    } else {
      broadIndex += 1;
    }
  }

  if (broadIndex == 0) {
    return _("IP address cannot be a broadcast IP address");
  }

  return;
}

/**
 * @method [判断IP地址的大小]
 * @param  {string} ip   [IP地址]
 * @param  {string} ip [ip地址]
 * @return {string}      [ 若大于，则返回true。否则，返回false]
 */
export function checkIpComparison(ipFirst, ipSecond) {
  let i,
    firstArr = ipFirst.split("."),
    secondArr = ipSecond.split(".");

  for (i = 0; i < firstArr.length; i++) {
    if (parseInt(firstArr[i]) > parseInt(secondArr[i])) {
      return true;
    } else if (parseInt(firstArr[i]) < parseInt(secondArr[i])) {
      return false;
    }
  }
  return false;
}

//处理时间变成 天 时分秒
export function formatSeconds(value) {
  let theTime = parseInt(value),
    timeMin = 0,
    // 分
    timeHour = 0,
    // 小时
    timeDay = 0; // 天

  if (isNaN(theTime)) {
    return "--";
  }
  if (theTime < 60) {
    return timeMin + _("分钟");
  }

  timeMin = ~~(theTime / 60);
  theTime = ~~(theTime % 60);
  // alert(theTime1+"-"+theTime);
  if (timeMin > 60) {
    timeHour = ~~(timeMin / 60);
    timeMin = ~~(timeMin % 60);
    if (timeHour > 24) {
      timeDay = ~~(timeHour / 24);
      timeHour = ~~(timeHour % 24);
    }
  }

  //let result = "" + theTime + _("秒");
  let result = "";
  if (timeMin > 0) {
    result = "" + timeMin + _("分钟");
  }
  if (timeHour > 0) {
    result = "" + timeHour + _("小时") + " " + result;
  }
  if (timeDay > 0) {
    result = "" + timeDay + _("天") + " " + result;
  }
  return result;
}

/**
 *  年月日 时分秒 转换
 * @param {*} isoDateString  2024-08-20T11:22:07.653Z
 * @returns 
 */
export function convertToYMDHMS(isoDateString) {  
  // 创建一个Date对象  
  const date = new Date(isoDateString);  

  // 提取年、月、日、时、分、秒  
  // 注意：月份是从0开始的，所以需要+1  
  const year = date.getFullYear();  
  const month = (date.getMonth() + 1).toString().padStart(2, '0');  
  const day = date.getDate().toString().padStart(2, '0');  
  const hours = date.getHours().toString().padStart(2, '0');  
  const minutes = date.getMinutes().toString().padStart(2, '0');  
  const seconds = date.getSeconds().toString().padStart(2, '0');  

  // 格式化并返回结果  
  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;  
} 


//差集
//返回数组A中去掉与数组B有相同prop值的选项
export function minusArr(a, b, prop) {
  return a.filter(a1 => {
    return !b.some(b1 => b1[prop] === a1[prop]);
    //return b.indexOf(v) == -1;
  });
}

//并集
export function unionArr(a, b) {
  return a.concat(
    b.filter(function(v) {
      return !(a.indexOf(v) > -1);
    })
  );
}

//两个数组并集
//返回数组A + B 中去掉相同prop值的选项
export function unionArrProp(a, b, prop) {
  return a.concat(minusArr(b, a, prop));
}

/**
 * @description 将字符串转码
 * @param { String } str
 * @returns
 */
export function toHtmlCode(str) {
  if (typeof str != "string") {
    return str;
  } else {
    return str
      ? str.replace(/[< >"&]/g, function(char) {
          switch (char) {
            case "<":
              return "&lt;";
            case ">":
              return "&gt;";
            case '"':
              return "&quot;";
            case " ":
              return "&nbsp;";
            case "&":
              return "&amp;";
          }
        })
      : "";
  }
}

//速度转换
export function translateSpeed(value) {
  let val = parseFloat(value);
  if (isNaN(val)) {
    return "--";
  }
  if (val > 1024) {
    return (val / 1024).toFixed(2) + "MB/s";
  } else {
    return val.toFixed(0) + _("KB/s");
  }
}

export function getUtf8Length(str) {
  let totalLength = 0,
    charCode,
    len = str.length,
    i;

  for (i = 0; i < len; i++) {
    charCode = str.charCodeAt(i);
    if (charCode < 0x007f) {
      totalLength++;
    } else if (0x0080 <= charCode && charCode <= 0x07ff) {
      totalLength += 2;
    } else if (0x0800 <= charCode && charCode <= 0xffff) {
      totalLength += 3;
    } else {
      totalLength += 4;
    }
  }
  return totalLength;
}

/**
 * @description 删除最后字符串，如果是表情，则多删除一位（表情包长度不止1位，导致出现乱码情况）
 * @param {String} str
 * @returns 去除视觉上的最后一位字符
 */
function cutStrEmoji(str) {
  str = str.slice(0, -1);
  try {
    //如果正常转义
    encodeURIComponent(str);
  } catch (e) {
    str = cutStrEmoji(str);
  }
  return str;
}

/**
 * @description 截取指定长度的字符串
 * @export
 * @param {String} str 需要截取的字符串
 * @param {Number} len 长度
 * @returns
 */
export function cutStrLen(str, len) {
  let strByte = getUtf8Length(str); //先计算字符串的总字节数，利用了上边的sizeOf

  while (strByte > len) {
    //如果总字节数大于理想字节数
    str = cutStrEmoji(str);
    strByte = getUtf8Length(str); //计算删除后的总字节数，直到小于理想字节数oByte
  }

  return str;
}

/**
 * 密码强度校验
 * @param {string} str 密码
 * 数字 、大写、小写 各占 权值 1
 * 特殊字符 权值 2
 * 总权值 1为弱 2为中 3为强
 * 长度小于 8 弱
 * 特殊字符 + 数字 权值为 2
 * 只有特殊字符 权值 为 1
 * 特殊字符 + 字母 权值为 3
 */
export function getPwdLevel(str) {
  let hasNum = /\d/.test(str) ? 1 : 0,
    hasLowerCase = /[a-z]/.test(str) ? 1 : 0,
    hasUpperCase = /[A-Z]/.test(str) ? 1 : 0,
    hasOther = /[^\da-zA-Z]/.test(str) ? 2 : 0;

  let sum = hasNum + hasLowerCase + hasUpperCase + hasOther;

  if (str.length < 8) {
    return 1;
  }
  //只有特殊字符 权值减一
  if (!!hasOther && sum === 2) {
    sum--;
  }

  //特殊字符 + 数字时 需要减一
  if (!!hasOther && !!hasNum) {
    sum--;
  }

  if (sum >= 3) {
    return 3;
  }

  if (sum <= 1) {
    return 1;
  }

  return 2;
}

//端口排序，并输出以-连接的端口
export function getNumList(list, config = {}) {
  let joiner = config.joiner || "-",
    //连接符
    spliter = config.spliter || ",",
    //分隔符
    dataObj = config.data || {}; //数据对象
  //排序
  let arr = copy(list);
  arr = arr.sort((a, b) => Number(a) - Number(b));

  let str = "",
    endIndex;
  for (let i = 0; i < arr.length; i++) {
    let start = arr[i],
      end;
    endIndex = i;
    for (let j = i; j < arr.length; j++) {
      if (arr[i] - i == arr[j] - j) {
        endIndex = j;
        end = arr[j];
      }
    }

    if (end - start >= 2) {
      str +=
        (dataObj[start] || start) + joiner + (dataObj[end] || end) + spliter;
      i = endIndex;
    } else {
      str += (dataObj[start] || start) + spliter;
    }
  }

  str = str.slice(0, -spliter.length);
  return str;
}

/**
 * 将字符串010101 转成日期的数组
 * @param {*} dateStr 日期字符串
 * @returns 日期数组，适配checkbox组件
 */
export function getRealDate(dateStr) {
  let dateArr = [];
  let index = 1;
  for (let str of dateStr) {
    str == "1" && dateArr.push(String(index));
    index++;
  }
  return dateArr;
}

/**
 * 将数组转成日期的字符串
 * @param {*} dateArr
 * @returns 日期字符串
 */
export function getDateStr(dateArr) {
  let datelist = "0".repeat(7).split("");

  dateArr.map(val => {
    datelist[Number(val) - 1] = "1";
  });

  return datelist.join("");
}
// 给数组添加 key id
export function addId(list) {
  list.forEach((item, index) => {
    item.id = index;
  });
}

export function checkIpv6InSameSegment(addr1, addr2, prefixLen1, prefixLen2) {
  //如果两个前缀长度不一样，就是不同网段
  prefixLen1 = parseInt(prefixLen1, 10);
  prefixLen2 = parseInt(prefixLen2, 10);
  if (prefixLen1 != prefixLen2) {
    return false;
  }
  //计算两个地址的二进制
  //截取前{prefixLen}位进行比较，如果一样，则为同网段
  let prefixLen = prefixLen1,
    binaryAddr1 = toBinary(getFullIpv6(addr1)),
    binaryAddr2 = toBinary(getFullIpv6(addr2)),
    compareAddr1 = binaryAddr1.slice(0, prefixLen),
    compareAddr2 = binaryAddr2.slice(0, prefixLen);

  if (compareAddr1 == compareAddr2) {
    return true;
  } else {
    return false;
  }
}

/**
 * @method 计算完整的ipv6地址，并去掉:
 *
 * @param {addr} ipv6地址
 */
function getFullIpv6(addr) {
  var addrLen,
    fullAddr = "",
    //补全后的地址，无:/::
    splitAddr = addr.split("::"),
    shortAddr1 = splitAddr[0].split(":"),
    shortAddr2 = [],
    abbAddr = "",
    abbAddrLen,
    i;
  //没有::，长度为8，有双冒号时需要计算
  if (addr.indexOf("::") !== -1) {
    shortAddr2 = splitAddr[1].split(":");
    addrLen = shortAddr1.length + shortAddr2.length;
    abbAddrLen = 8 - addrLen;
    //简写处补全0，不需要:隔开，分别获取::前后数字后将abbAddr插在中间
    while (abbAddrLen) {
      abbAddr += "0000";
      abbAddrLen--;
    }
  }
  //以:隔开的地址不足4位补全
  //::前
  for (i = 0; i < shortAddr1.length; i++) {
    while (shortAddr1[i].length < 4) {
      //如果每一节不够4个字符，在前面加0,补全
      shortAddr1[i] = "0" + shortAddr1[i];
    }
    fullAddr += shortAddr1[i];
  }

  fullAddr += abbAddr;

  //::后
  for (i = 0; i < shortAddr2.length; i++) {
    while (shortAddr2[i].length < 4) {
      //如果每一节不够4个字符，在前面加0,补全
      shortAddr2[i] = "0" + shortAddr2[i];
    }
    fullAddr += shortAddr2[i];
  }
  return fullAddr;
}

/**
 *
 * @param {string} str 字符串
 * method 将字符串转为二进制并补全
 */
function toBinary(str) {
  var len = str.length,
    resultStr = "",
    shortStr = "";
  for (var i = 0; i < len; i++) {
    //拆分字符串的每一位
    shortStr = parseInt(str[i], 16).toString(2);

    while (shortStr.length < 4) {
      shortStr = "0" + shortStr;
    }
    resultStr += shortStr;
  }
  return resultStr;
}

/**
 * 2.4GHz信号强度转换
 * @param  {number} signal -100 ~ 0, 0最强
 * @return {object}
 *
 *  > 54     4格信号  100% ~ 71%
 * -55 ~ -64 3格信号  70% ~ 55%
 * -65 ~ -75 2格信号  54% ~ 40%
 *  <-76     1格信号  39% ~ 0
 */
export function transformSignal(signal) {
  var level = "",
    //信号图的索引
    newPer = ""; //信号百分比
  signal = parseInt(signal, 10);

  if (signal >= 0) {
    //>=0时，信号格数为4格，信号强度百分比为100%
    newPer = "100%";
    level = 4;
  } else if (signal > -54) {
    //-53~-1时，信号格数为4格，信号强度百分比为71~99%
    newPer = 71 + Math.round((53 + signal) * ((99 - 71) / 52)) + "%";
    level = 4;
  } else if (signal > -65) {
    //-64~-55时，信号格数为3格，信号强度百分比为61~70%；
    newPer = 55 + Math.round((64 + signal) * ((70 - 55) / (64 - 55))) + "%";
    level = 3;
  } else if (signal >= -75) {
    //-75~-65dB时，信号格数为2格，信号强度百分比为40~60%
    newPer = 40 + Math.round((75 + signal) * ((54 - 40) / (75 - 65))) + "%";
    level = 2;
  } else {
    //~-76时，信号格数为1格，信号强度百比为0~39%；
    newPer = 0 + Math.round((100 + signal) * (39 / (100 - 76))) + "%";
    level = 1;
  }

  if (signal <= -100) {
    newPer = "0%";
  }

  return {
    imageIndex: level,
    percent: newPer,
  };
}

/**
 * 5GHz信号强度转换
 * @param  {number} signal -100 ~ 0, 0最强
 * @return {object}
 *
 *  > 51     4格信号  100% ~ 71%
 * -52 ~ -61 3格信号  70% ~ 55%
 * -62 ~ -72 2格信号  54% ~ 40%
 *  <-73     1格信号  39% ~ 0
 */
export function transformSignal_5g(signal) {
  var level = "",
    //信号图的索引
    newPer = ""; //信号百分比
  signal = parseInt(signal, 10);

  if (signal >= 0) {
    //>=0时，信号格数为4格，信号强度百分比为100%
    newPer = "100%";
    level = 4;
  } else if (signal > -51) {
    //-50~-1时，信号格数为4格，信号强度百分比为71~99%
    newPer = 71 + Math.round((50 + signal) * ((99 - 71) / 49)) + "%";
    level = 4;
  } else if (signal > -62) {
    //-61~-52时，信号格数为3格，信号强度百分比为61~70%；
    newPer = 55 + Math.round((61 + signal) * ((70 - 55) / (61 - 52))) + "%";
    level = 3;
  } else if (signal >= -72) {
    //-72~-62dB时，信号格数为2格，信号强度百分比为40~60%
    newPer = 40 + Math.round((72 + signal) * ((54 - 40) / (72 - 62))) + "%";
    level = 2;
  } else {
    //~-73时，信号格数为1格，信号强度百比为0~39%；
    newPer = 0 + Math.round((100 + signal) * (39 / (100 - 73))) + "%";
    level = 1;
  }

  if (signal <= -100) {
    newPer = "0%";
  }

  return {
    imageIndex: level,
    percent: newPer,
  };
}

/**
 * @method 计算时区
 * @param  {boolean} 是否需要精确到分钟
 */
export function getTimeZone(isMinute) {
  var date = new Date();
  var timeZone = parseInt(-date.getTimezoneOffset() / 60);
  var minute = Math.abs(date.getTimezoneOffset() % 60);
  var year = date.getFullYear();
  for (var i = 1; i < 13; i++) {
    var monthDate = parseInt(
      -new Date(year + "/" + i + "/" + "01").getTimezoneOffset() / 60
    );
    if (monthDate != timeZone) {
      timeZone = Math.min(monthDate, timeZone);
      break;
    }
  }
  timeZone = 12 + timeZone;
  minute = minute == 0 ? "00" : minute;
  if (isMinute) {
    return timeZone + ":" + minute;
  } else {
    return timeZone + ":00";
  }
}

/**
 * @method 将图片使用base64编码
 */
export function base64Img(obj) {
  for (var img in obj) {
    let image = new Image();
    image.crossOrigin = "Anonymous";
    image.name = img;
    image.onload = function() {
      var canvas = document.createElement("canvas");
      canvas.width = this.width;
      canvas.height = this.height;
      var cxt = canvas.getContext("2d");
      cxt.drawImage(this, 0, 0, this.width, this.height);
      var dataURL = canvas.toDataURL();
      sessionStorage.setItem(this.name, dataURL);
      canvas = null;
    };
    image.src = "http://" + window.location.host + obj[img];
  }
}

/**
 * @method 链接文件下载，TXT等
 */
export function downloadUrlFile(url) {
  url = url.replace(/\\/g, '/');
  const xhr = new XMLHttpRequest();
  xhr.open('GET', url, true);
  xhr.responseType = 'blob';
  //xhr.setRequestHeader('Authorization', 'Basic a2VybWl0Omtlcm1pdA==');
  xhr.onload = () => {
      if (xhr.status === 200) {
          // 获取文件blob数据并保存
          var fileName = getFileName(url);
          saveAs(xhr.response, fileName);
      }
  };
  xhr.send();
}

/**
 * @method 根据文件url获取文件名
 */
export function  getFileName(url) {
  var num = url.lastIndexOf('/') + 1
  var fileName = url.substring(num)
      //把参数和文件名分割开
  fileName = decodeURI(fileName.split("?")[0]);
  return fileName;
}

/**
 * @method URL方式保存文件到本地
 */
export function  saveAs(data, name) {
  var urlObject = window.URL || window.webkitURL || window;
  var export_blob = new Blob([data]);
  var save_link = document.createElementNS('http://www.w3.org/1999/xhtml', 'a')
  save_link.href = urlObject.createObjectURL(export_blob);
  save_link.download = name;
  save_link.click();
}